'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = InputLabel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

var _Form = require('../Form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('InputLabel', function (theme) {
  var transitions = theme.transitions,
      typography = theme.typography,
      variables = theme.variables;

  return {
    root: theme.mixins.truncate({
      transformOrigin: 'top left',
      width: '100%',
      maxWidth: '100%',
      textAlign: 'left',
      zIndex: theme.zIndex.formLabel
    }),
    rootInlineAction: {
      width: 'calc(100% - ' + variables.textFieldPadding + 'px)'
    },
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      transform: 'translate(0, ' + (variables.formControlMarginTop + 4) + 'px) scale(1)', // Offset padding and border: 4px
      fontSize: typography.verticalRhythmByPixel(14).fontSize,
      lineHeight: typography.verticalRhythmByPixel(parseInt(typography.rhythmByUnit(2))).lineHeight
    },
    formControlDescription: {
      transform: 'translate(0, ' + (variables.formControlMarginTop * 2 + 4) + 'px) scale(1)' // Offset description, padding and border: 4px
    },
    formControlPadding: theme.mixins.gutters(1),
    shrink: {
      transform: 'translate(0, 0) scale(0.75)',
      transformOrigin: 'top left',
      width: '133%', // 133% <= 100% / .75 (scale ratio when shrunk)
      maxWidth: '133%', // Override Bootstap's maxWidth property on labels
      fontSize: typography.verticalRhythmByPixel(15 * 1.25).fontSize,
      lineHeight: typography.verticalRhythmByPixel(parseInt(typography.rhythmByUnit(2)) * 1.25).lineHeight
    },
    shrinkPadding: {
      paddingLeft: 0
    },
    floatingLabelFixed: Object.assign({
      position: 'static',
      overflow: 'visible',
      whiteSpace: 'normal',
      textOverflow: 'clip',
      marginBottom: typography.rhythmByUnit(-2),
      transform: 'none',
      transformOrigin: '50% 50% 0',
      width: '100%',
      maxWidth: '100%'
    }, typography.verticalRhythmByPixel(14)),
    animated: {
      transition: transitions.create(['transform', 'width', 'max-width', 'padding-left', 'font-size', 'line-height'], {
        duration: transitions.duration.shorter,
        easing: transitions.easing.easeOut
      })
    }
  };
});

function InputLabel(props, context) {
  var _classNames;

  var children = props.children,
      classNameProp = props.className,
      description = props.description,
      disableAnimation = props.disableAnimation,
      floatingLabelFixed = props.floatingLabelFixed,
      inlineAction = props.inlineAction,
      shrinkProp = props.shrink,
      underline = props.underline,
      other = _objectWithoutProperties(props, ['children', 'className', 'description', 'disableAnimation', 'floatingLabelFixed', 'inlineAction', 'shrink', 'underline']);

  var muiFormControl = context.muiFormControl,
      muiForm = context.muiForm,
      styleManager = context.styleManager;

  var classes = styleManager.render(styleSheet);
  var hasBorder = muiForm && underline === undefined || underline;

  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.dirty || muiFormControl.focused;
  }

  var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.rootInlineAction, inlineAction), _defineProperty(_classNames, classes.formControl, muiFormControl), _defineProperty(_classNames, classes.formControlDescription, muiFormControl && description), _defineProperty(_classNames, classes.formControlPadding, muiFormControl && hasBorder), _defineProperty(_classNames, classes.animated, !disableAnimation), _defineProperty(_classNames, classes.shrink, shrink), _defineProperty(_classNames, classes.shrinkPadding, shrink && hasBorder), _defineProperty(_classNames, classes.floatingLabelFixed, floatingLabelFixed), _classNames), classNameProp);

  return _react2['default'].createElement(
    _Form.FormLabel,
    _extends({ className: className, ellipsize: !floatingLabelFixed }, other),
    children
  );
}

InputLabel.displayName = 'InputLabel';

InputLabel.propTypes = {
  /**
   * The contents of the InputLabel.
   */
  children: _PropTypes2['default'].node,
  /**
   * The css class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If true, the input of this label has a description.
   */
  description: _PropTypes2['default'].bool,
  /**
   * If true, the transition animation is disabled.
   */
  disableAnimation: _PropTypes2['default'].bool,
  /**
   * If true, the label will be displayed in an error state.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If 'true', floating label will float even when there is no value
   */
  floatingLabelFixed: _PropTypes2['default'].bool,
  /**
   * If true, the input of this label is focused.
   */
  focused: _PropTypes2['default'].bool,
  /**
   * A component representing one or more actions shown to the right of the field
   */
  inlineAction: _PropTypes2['default'].node,
  /**
   * If true, the label will indicate that the input is required.
   */
  required: _PropTypes2['default'].bool,
  /**
   * If true, the label will display an asterisk as if the input is required.
   */
  requiredAsterisk: _PropTypes2['default'].bool,
  /**
   * If true, the label is shrunk.
   */
  shrink: _PropTypes2['default'].bool,
  /**
   * If set to true, the label will have additional padding.
   */
  underline: _PropTypes2['default'].bool
};

InputLabel.defaultProps = {
  disableAnimation: false
};

InputLabel.contextTypes = {
  muiForm: _PropTypes2['default'].object,
  muiFormControl: _PropTypes2['default'].object,
  styleManager: _PropTypes2['default'].styleManager.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Input/InputLabel.js
// module id = 1854
// module chunks = 32